import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OrderStatus, EDPStatus, EDPStatusLabel, EntityType, USER_ROLE_KEYS, ChatMetaData } from 'src/app/shared/constants/constants';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { OmsServiceService } from '../service/oms-service.service';
import { first } from 'lodash';

@Component({
  selector: 'app-order-inprogress-details',
  templateUrl: './order-inprogress-details.component.html',
  styleUrls: ['./order-inprogress-details.component.scss'],
})
export class OrderInprogressDetailsComponent {
  orderId: any = this.route.snapshot.paramMap.get('id');
  baseUrl = environment.BASE_URL;
  orderDetail: any;
  isChecked: boolean[] = [];
  OrderStatus = OrderStatus;
  EDPStatus = EDPStatus;

  selectDate: any = null;

  @Input() disabled: boolean = false;
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  getIndex: any;
  getMilesId: number[] = [];
  selectedMileStones: Map<number, any> = new Map();
  yesterday = new Date();
  commentPanelActive: boolean = false;

  chatRefId!: any;
  metaData: ChatMetaData = {
    service: EntityType.OMS,
    receivers: [USER_ROLE_KEYS.Business_Development],
    canAddComment: true,
    entityType: EntityType.MILESTONE,
    hasNewComment: false,
  };
  entityType = EntityType;
  milestoneName = '';
  entityId!: number | undefined;
  readStatus: any[] = [];
  readMileStatus: Map<number, any> = new Map();

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
    private toastr: ToastrService,
    private omsService: OmsServiceService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getOrderById();
    this.selectDate = new Date();
    this.selectDate.setDate(this.selectDate.getDate());
    this.yesterday.setDate(this.yesterday.getDate() - 0);
  }

  openDatePicker(datePicker: MatDatepicker<Date>) {
    datePicker.open();
  }

  selectedDate(event: any): void {
    this.selectDate = event.value;
  }

  getOrderById() {
    this.omsService.getById(this.orderId).subscribe((data: any) => {
      this.orderDetail = data?.response;
      const milestonesIds: any = [];
      this.orderDetail?.customerEdp?.customerMilestones.forEach((mile: any) => {
        milestonesIds.push(mile.id);
        mile['comments'] = '';
        mile['subMileStoneId'] = '';

        this.setOnTimeStatus(mile);
      });
      if (milestonesIds.length) {
        this.getMileStonesComments(milestonesIds, EntityType.MILESTONE);
      }
    });
  }

  setOnTimeStatus(mile: any) {
    if (
      mile.actualStartDate &&
      mile.actualEndDate &&
      new Date(mile.actualEndDate) <= new Date(mile.endDate)
    ) {
      mile.onTime = true;
    }
  }

  getMileStonesComments(milestonesIds: any, entityType: EntityType) {
    this.omsService
      .requestMilestoneCommentStatus(milestonesIds, entityType, EntityType.OMS)
      .subscribe({
        next: (mileWithNewComments: any) => {
          mileWithNewComments.response.forEach((mileComment: any) => {
            this.readMileStatus.set(
              Number(first(Object.keys(mileComment))),
              first(Object.values(mileComment)),
            );
          });
        },
        error: (e) => {
          this.toastr.error(e.error.status.error.message);
        },
      });
  }

  checkMilestones(checked: boolean, index: number, milesId: number, subMile?: number) {
    if (checked) {
      this.selectedMileStones.set(index, milesId);
    } else {
      this.selectedMileStones.delete(index);
    }
  }

  getEdpStatusLabel(edpStatus: EDPStatus): EDPStatusLabel {
    return EDPStatusLabel[edpStatus];
  }

  getCompletedStatus(mile: any) {
    let completedStatus = '';
    if (mile.actualStartDate && mile.actualEndDate) {
      completedStatus = 'Completed';
    } else if (mile.actualStartDate) {
      completedStatus = 'In Progress';
    }

    return completedStatus;
  }

  getCommentStatus(id: number): boolean {
    let hasProperty = true;
    if (this.readMileStatus.has(id)) {
      hasProperty = this.readMileStatus.get(id);
    }
    return hasProperty;
  }

  viewCommentSection(
    event: any,
    mileId: number,
    milestoneName: string,
    type: EntityType,
  ) {
    this.commentPanelActive = !this.commentPanelActive;
    event.preventDefault();
    if (type) {
      this.metaData.entityType = type;
    }
    document.body.classList.add('commentboxOpen');
    this.entityId = mileId;
    this.milestoneName = milestoneName;
    this.metaData.hasNewComment = this.getCommentStatus(mileId);
    if (mileId) {
      this.readMileStatus.set(mileId, true);
    }
  }

  closeCommentSection(event: any): void {
    this.commentPanelActive = !this.commentPanelActive;
    document.body.classList.remove('commentboxOpen');
    const milestonesIds: any = [];
    this.orderDetail?.customerEdp?.customerMilestones.forEach((mile: any) => {
      milestonesIds.push(mile.id);
    });

    if (milestonesIds.length) {
      this.getMileStonesComments(milestonesIds, EntityType.MILESTONE);
    }
  }
}
